module.exports = __webpack_public_path__ + "img/Pangue.e588de49.jpg";